import moment from 'moment';
import { DateUtil } from '@axiom/ui';

export const PreferencesUtil = {
  shouldPreferenceNeedReview: (reviewedAt?: string | null) => {
    return (
      !reviewedAt ||
      DateUtil.isDateBeforeDate(
        reviewedAt,
        moment().subtract(6, 'months').toDate()
      )
    );
  },
};
